<template>
  <div id="app">
    <router-view ref="header" name="topHeader"></router-view>
    <router-view name="swipe"></router-view>
    <router-view name="swipeList"></router-view>
    <router-view name="homePage0"></router-view>
    <router-view name="homePage1"></router-view>
    <router-view name="homePage2"></router-view>
    <router-view name="aps"></router-view>
    <router-view name="ac1"></router-view>
    <router-view name="ac2"></router-view>
    <router-view name="ac3"></router-view>
    <router-view ref="openapi" name="open"></router-view>
    <router-view name="shareContent"></router-view>
    <router-view name="aboutContent"></router-view>
    <router-view name="downloadContent"></router-view>
    <router-view name="jobContent"></router-view>
    <router-view name="login"></router-view>
    <router-view name="backend"></router-view>
    <router-view name="footer"></router-view>
    <router-view name="simpleFooter"></router-view>
    <div class="clearFloat"></div>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>

<style>
.auto {
  margin: 0 auto;
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
}

#app {
  width: 100%;
  height: 100vh;
  min-width: 1140px;
  margin: 0 auto;
  text-align: center;
  background-color: #e7e7e7;
}

#container {
  position: relative;
}

body {
  margin: 0;
  padding: 0;
}

.clearFloat {
  clear: both;
}

.paging {
  text-align: center;
  margin-top: 20px;
}

.el-dialog__header {
  background-color: #000;
}

.el-dialog__title {
  color: #fff;
}

.el-dialog__body {
  padding-bottom: 0px;
}

.el-message-box {
  width: 320px;
}

.div-title {
  background-color: #F4F4F4;
  padding: 15px 20px;
  font-size: 16px;
  font-weight: bold;
  user-select: none;
  display: flex;
  align-items: center;
}

.div-label {
  margin-left: 5px;
}

.block-60 {
  height: 60px;
  min-height: 60px;
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// App.vue?3dbb5da0